const safeNum = (v: unknown): number => {
  const n = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
  return Number.isFinite(n) ? n : 0;
};

type InvoiceAmountDueInput = {
  status?: string | null;
  total?: unknown;
  deposit?: unknown;
};

/** Amount the customer still owes (includes tip in total). Returns 0 for paid/voided invoices. */
export function getInvoiceAmountDue(invoice: InvoiceAmountDueInput): number {
  const status = String(invoice.status || '').toUpperCase();
  if (status === 'PAID' || status === 'VOIDED') return 0;
  return Math.max(0, safeNum(invoice.total) - safeNum(invoice.deposit));
}
